export function getQueryString(name: any) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);
    if(r != null) {
          return decodeURIComponent(r[2]);
    }
    return '';
}

export function getIsWxClient() {
    const ua = navigator.userAgent.toLowerCase();
    const r = ua.match(/MicroMessenger/i);
    if (r && r[0] === "micromessenger") {
        return true;
    }
    return false;
}

export function getCookie(name: string) {
  var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  if(arr=document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return '';
  }
}

export function deepClone(obj: any):any {
    const objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (obj[key] && typeof obj[key] === "object") {
            objClone[key] = deepClone(obj[key]);
          } else {
            objClone[key] = obj[key];
          }
        }
      }
    }
    return objClone;
  }